module.exports = {
      id: "politics-usage",
      viewBox: "0 0 93.75 88.955",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#politics",
      toString: function () {
        return this.url;
      }
    }